import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { QUERY_KEYS } from '@/utils/query-keys';

type StepResult = {
	step_name: string;
	value: string | null;
	questions: QuestionResult[];
};

type QuestionResult = {
	question_name: string;
	value: string;
};

interface CreateUpdateResolution886CategoryQuestionParams {
	organization_id: string;
	company_id: string;
	assessment_id: string;
	category_key: string;
	steps_results: StepResult[];
}

const Service = Resolution886ReportService.getInstance();

export function useCreateUpdateResolution886CategoryQuestion() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateUpdateResolution886CategoryQuestionParams) =>
			Service.createUpdateCategoryQuestion(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.CREATE_UPDATE_RESOLUTION_886_CATEGORY_QUESTION]);
		},
		onError: () => {
			message.error(I18n.get('Error creating assessment'));
		}
	});
}
